import { Auth } from '../auth/Auth';

export class BaseAuthService {
    protected auth: Auth;

    constructor() {
        this.auth = new Auth();
    }

    protected buildRequestInit(method: string, body?: any): RequestInit {
        let requestInit: RequestInit = {
            method: method,
            mode: 'cors',
            cache: 'default'
        };

        let headers = this.auth.getAuthHeaders();

        if (body) {
            headers!.append('content-type', 'application/json');
            requestInit.body = JSON.stringify(body);
        }

        requestInit.headers = headers;

        return requestInit;
    }
}


// WEBPACK FOOTER //
// ./src/services/api/BaseAuthService.tsx